// Dependencies
import { useSnackbar } from "notistack";
import { FC, useEffect, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

// custom hooks
import { useUserInfo } from "~/hooks";

// Components
import { ErrorBoundary } from "react-error-boundary";
import SideMenu from "~/components/Common/SideMenu";
import ErrorFallback from "~/components/ErrorFallback";

// Routes
import config from "~/config";
import { privateRoutes } from "../routes";

// api
import { getFCMToken, messaging } from "~/services/firebase";

// Styles
import { StyledLayoutBackground } from "./LayoutPage.styled";

interface LayoutPageProps {}

const LayoutPage: FC<LayoutPageProps> = () => {
  const [notifyPayload, setNotifyPayload] = useState<Object | null>(null);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const useInfo = useUserInfo();

  // get token for notifications
  getFCMToken();

  /***
   * check if user logged in, if user not logged in
   * then do not render layout and navigate to login page
   *  */
  useEffect(() => {
    if (!useInfo) {
      navigate(config.routes.login);
    }
  }, [navigate, useInfo]);

  /**
   * notify message when gotten it
   */
  useEffect(() => {
    messaging.onMessage((payload) => {
      enqueueSnackbar(payload.notification.body, { variant: "info" });
      setNotifyPayload(payload);
    });
  });

  if (!useInfo) {
    return <></>;
  }

  return (
    <StyledLayoutBackground>
      <SideMenu notifyPayload={notifyPayload} />
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Routes>
          {privateRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              Component={route.component}
            />
          ))}
          <Route
            path="/*"
            element={<Navigate to={config.routes.dashboard} />}
          />
        </Routes>
      </ErrorBoundary>
    </StyledLayoutBackground>
  );
};

export default LayoutPage;
